import * as types from './index';

export const crewUnavailabilityAction =(data) =>{ 
    return {
        type: types.CREW_UNAVAILABILITY,
        data
    }
}

export const crewUnavailabilityPerDateAction =(data) =>{ 
    return {
        type: types.CREW_UNAVAILABILITY_PER_DATE,
        data
    }
}

export const unavailableCrewListAction =(data) =>{ 
    return {
        type: types.UNAVAILABLE_CREW_LIST,
        data
    }
}
export const saveUnavailability =(data) =>{ 
    return {
        type: types.SAVE_UNAVAILABILITY,
        data
    }
}
export const updateUnavailability =(data) =>{ 
    return {
        type: types.UPDATE_UNAVAILABILITY,
        data
    }
}
export const deleteUnavailability =(data) =>{ 
    return {
        type: types.DELETE_UNAVAILABILITY,
        data
    }
}
export const getUnavailability =(data) =>{ 
    return {
        type: types.GET_UNAVAILABILITY,
        data
    }
}